import apiClient from '@/services/axios'

export async function patch(calendarEntryId, calendarEntry) {
  var response = await apiClient.patch(process.env.VUE_APP_MARCOM_API_BASE_URL + '/admin/venue-setup-calendar-entries/' + calendarEntryId, calendarEntry);

  if (response) {
    console.log(response)
    return response.data;
  }

  throw new Error('Unable to patch calendar entry.')
}
